import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { TRequestListDesktop, IDepsDesktop } from './models';
import { RequestList as Component } from './request-list';
import styles from './styles/desktop.css';

export const RequestListDesktop = createWidget<IDepsDesktop, TRequestListDesktop>({
    styles,
    Text,
    titleKind: 'caption',
    titleView: 'accent-tagline',
})(Component);
